import b1 from "./assets/blog/blog_post_1.png";
import b2 from "./assets/blog/blog_post_2.png";
import b3 from "./assets/blog/blog_post_3.png";
import b4 from "./assets/blog/blog_post_4.png";
import b5 from "./assets/blog/blog_post_5.png";
import b6 from "./assets/blog/blog_post_6.png";

export const BLOG_POSTS = [
  {
    id: 1,
    slug: "fast-food-frenzy-taste-of-convenience",
    day: "15",
    month: "Dec",
    year: "2025",
    author: "Admin",
    tag: "Noodles",
    category: "Fast Food",
    title: "Fast Food Frenzy A Taste Of Convenience",
    imgUrl: b1,
    views: 1240,
    commentsCount: 2,
    excerpt:
      "Explore the fascinating rise of premium fast food, where convenience meets gourmet ingredients to redefine quick dining in modern times.",
    content: [
      {
        type: "paragraph",
        text: "In today's fast-paced world, the demand for quick, delicious, and reliable food has never been higher. The traditional boundaries between quick service and premium dining are blurring. We are entering an era of 'gourmet fast food' or fast-casual concepts where diners no longer have to compromise on quality to get their meals quickly.",
      },
      {
        type: "paragraph",
        text: "At Flakes Fried Chicken, we believe that convenience shouldn't mean cutting corners. Every piece of chicken is hand-breaded and prepared fresh using our secret blend of herbs and spices. It's this commitment to high-quality cooking and ingredients that transforms a simple quick meal into a memorable culinary experience.",
      },
      {
        type: "blockquote",
        text: "Good food is all the sweeter when shared with the ones you love, and fast food makes those spontaneous moments of connection easier than ever.",
      },
      {
        type: "paragraph",
        text: "From crispy chicken strips to perfectly toasted buns, the secret to outstanding fast food lies in the details. Fast food is no longer just about speed; it's about consistency, taste, and the joy of satisfying cravings instantly with fresh, sizzling hot dishes.",
      },
    ],
    comments: [
      {
        id: 1,
        author: "Rahul Sharma",
        date: "Dec 16, 2025",
        text: "Totally agree! The quality of crispy chicken at Flakes is unmatched. It feels fresh and not greasy at all.",
      },
      {
        id: 2,
        author: "Priya Patel",
        date: "Dec 17, 2025",
        text: "The combination of speed and quality is indeed hard to pull off, but you guys have nailed it.",
      },
    ],
  },
  {
    id: 2,
    slug: "benefits-of-health-and-safety-measures",
    day: "15",
    month: "Dec",
    year: "2025",
    author: "Admin",
    tag: "Noodles",
    category: "Health & Safety",
    title: "Benefits Of Health And Safety Measures",
    imgUrl: b2,
    views: 980,
    commentsCount: 1,
    excerpt:
      "Understand the critical importance of hygiene, strict safety regulations, and premium 100% Halal sourcing in contemporary restaurant management.",
    content: [
      {
        type: "paragraph",
        text: "Food safety is not just a regulatory checklist; it is the absolute foundation of trust between a kitchen and its patrons. In the modern dining landscape, customers deserve full transparency about where their food comes from, how it is handled, and the standards of cleanliness maintained.",
      },
      {
        type: "paragraph",
        text: "From temperature-controlled storage to strict sanitization cycles, a premium kitchen ensures that every point in the food supply chain is monitored. Sourcing plays a huge role in this. By ensuring that all meat is 100% Halal certified, we commit to ethical, hygienic, and humane standards of meat processing that naturally translate into cleaner, safer food.",
      },
      {
        type: "blockquote",
        text: "Safety in the kitchen is a daily practice, not a seasonal goal. Respect for the ingredients is respect for the customer.",
      },
      {
        type: "paragraph",
        text: "Ultimately, when a restaurant invests heavily in health and safety, the food tastes better because it is prepared with absolute care and respect. It guarantees peace of mind, making the dining experience completely worry-free and relaxing.",
      },
    ],
    comments: [
      {
        id: 1,
        author: "Dr. Anish Mehta",
        date: "Dec 16, 2025",
        text: "As a health professional, I appreciate the detailed focus on hygiene and Halal certification. It makes a huge difference.",
      },
    ],
  },
  {
    id: 3,
    slug: "quick-cravings-unraveling-fast-food-delights",
    day: "15",
    month: "Dec",
    year: "2025",
    author: "Admin",
    tag: "Noodles",
    category: "Food Stories",
    title: "Quick Cravings Unraveling Fast Food Delights",
    imgUrl: b3,
    views: 1450,
    commentsCount: 3,
    excerpt:
      "Unpacking the science of cravings and how a combination of crunch, spice, and warmth creates the perfect comfort food experience.",
    content: [
      {
        type: "paragraph",
        text: "Why do we crave crispy food? Science tells us that the auditory crunch of a bite enhances our perception of freshness and flavor. Cravings are powerful sensory journeys, triggered not just by hunger, but by memory, smell, and visual beauty.",
      },
      {
        type: "paragraph",
        text: "A bucket of golden, crispy fried chicken is the ultimate crowd-pleaser because it ticks all the sensory boxes. The contrast between a crunchy outer coating and tender, juicy meat inside triggers a positive texture profile that food scientists refer to as 'dynamic contrast.'",
      },
      {
        type: "blockquote",
        text: "Cravings are the body's way of asking for a moment of indulgence. The perfect bite is a balance of crunch, spice, and warmth.",
      },
      {
        type: "paragraph",
        text: "When you pair that crunch with hot, zesty dipping sauces and cold refreshing beverages, you create a flavor symmetry that satisfies the soul. Next time you grab a quick bite, take a moment to savor that initial crunch—it's food craft at its finest!",
      },
    ],
    comments: [
      {
        id: 1,
        author: "Vikram Sen",
        date: "Dec 15, 2025",
        text: "Dynamic contrast is exactly what describes Flakes Fried Chicken. Every bite is an experience!",
      },
      {
        id: 2,
        author: "Sneha Reddy",
        date: "Dec 16, 2025",
        text: "This article makes me want to order a bucket right now. Love the writing!",
      },
      {
        id: 3,
        author: "Joshua D",
        date: "Dec 17, 2025",
        text: "My craving for wings is real now. Getting some tonight!",
      },
    ],
  },
  {
    id: 4,
    slug: "elevating-the-classic-hamburger-experience",
    day: "18",
    month: "Dec",
    year: "2025",
    author: "Admin",
    tag: "Burger",
    category: "Burgers",
    title: "Elevating The Classic Hamburger Experience",
    imgUrl: b4,
    views: 1120,
    commentsCount: 0,
    excerpt:
      "What makes a burger truly elite? Dive into the layering logic, cheese selection, and the ultimate chicken patty preparation tips.",
    content: [
      {
        type: "paragraph",
        text: "The hamburger is a simple canvas that allows for infinite creativity. While traditional beef burgers have their place, the crispy chicken burger has taken the culinary world by storm, offering an incredible crunch, juicy interior, and a lighter yet satisfying profile.",
      },
      {
        type: "paragraph",
        text: "To build an elite chicken burger, structure matters. You start with a brioche bun, toasted in premium butter to prevent it from getting soggy. Then comes the secret sauce, fresh crispy lettuce for cooling crunch, followed by a thick, crunchy fried chicken breast fillet. Top it with melted cheese and pickles for that perfect acid balance.",
      },
      {
        type: "blockquote",
        text: "A burger is not just food; it is an engineering marvel of flavors. Each layer must serve a purpose.",
      },
      {
        type: "paragraph",
        text: "Whether you like it spicy with peri-peri dust or sweet and smoky with BBQ glaze, the key is balance. Every ingredient should harmonize, ensuring that no single flavor overpowers the star of the show: the perfectly crispy chicken patty.",
      },
    ],
    comments: [],
  },
  {
    id: 5,
    slug: "the-art-of-perfect-grilling-herbs-and-heat",
    day: "20",
    month: "Dec",
    year: "2025",
    author: "Admin",
    tag: "Chicken",
    category: "Cooking Tips",
    title: "The Art Of Perfect Grilling: Herbs And Heat",
    imgUrl: b5,
    views: 890,
    commentsCount: 1,
    excerpt:
      "Master the grill with our expert tips on heat management, aromatic spice rubs, and keeping your chicken incredibly juicy.",
    content: [
      {
        type: "paragraph",
        text: "Grilling is one of the oldest and most satisfying cooking techniques known to humanity. It's a dance between smoke, flame, and temperature control. Unlike frying, which locks in moisture with a batter, grilling relies on marinade penetration and precise timing to keep meat tender and succulent.",
      },
      {
        type: "paragraph",
        text: "The secret to mouthwatering grilled chicken lies in the marinade. Acids like lemon juice or yogurt tenderize the protein fibers, while aromatic herbs like rosemary, thyme, and garlic infuse deep flavor. Cooking over indirect heat first, and finishing with a high-heat sear, creates a gorgeous caramelized crust without drying out the center.",
      },
      {
        type: "blockquote",
        text: "Grilling is about patience. You cannot rush the fire, or you will burn the outside while leaving the inside raw.",
      },
      {
        type: "paragraph",
        text: "Resting the meat is the final, crucial step. Letting the grilled chicken rest for 5 to 7 minutes allows the hot juices to redistribute throughout the meat, guaranteeing that every single bite is juicy and packed with herbal goodness.",
      },
    ],
    comments: [
      {
        id: 1,
        author: "Chef Koushik",
        date: "Dec 21, 2025",
        text: "Spot on advice about resting the meat! It is the most ignored but most important step in grilling.",
      },
    ],
  },
  {
    id: 6,
    slug: "sharing-the-crunch-why-family-buckets-bind-us",
    day: "22",
    month: "Dec",
    year: "2025",
    author: "Admin",
    tag: "flakesfriedchickens",
    category: "Food Stories",
    title: "Sharing The Crunch Why Family Buckets Bind Us",
    imgUrl: b6,
    views: 1670,
    commentsCount: 2,
    excerpt:
      "Food is meant to be shared. Explore why sharing a bucket of crispy tenders and fries brings families and friends closer together.",
    content: [
      {
        type: "paragraph",
        text: "Since the dawn of history, eating has been a communal act. Sharing a meal is a sign of peace, friendship, and family bonding. There is something uniquely casual and joyful about sharing food from a single, large container rather than individual plates.",
      },
      {
        type: "paragraph",
        text: "A family bucket of chicken tenders, wings, and fries represents the pinnacle of sharing food. It strips away formal table etiquette, inviting everyone to dive in, pass the dipping sauces, and laugh together. It encourages conversation, turns dinner into an interactive event, and creates shared memories.",
      },
      {
        type: "blockquote",
        text: "A family that shares a bucket of crispy chicken stays happy together. Communal dining is the ultimate social glue.",
      },
      {
        type: "paragraph",
        text: "In our digital age, sitting down to share a bucket of chicken is a simple, analog pleasure that pulls us away from our screens. It's an invitation to connect, tell stories, and bond over the universal language of crispy, delicious food.",
      },
    ],
    comments: [
      {
        id: 1,
        author: "The Kumar Family",
        date: "Dec 23, 2025",
        text: "Our weekend ritual is ordering the Flakes chicken bucket. Our kids absolutely love the tenders!",
      },
      {
        id: 2,
        author: "Arun Kumar",
        date: "Dec 24, 2025",
        text: "Nothing beats sharing food with friends. Great read.",
      },
    ],
  },
];
